/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyDrugBrandNames from './pharmacy-drug-brand-names';
import PharmacyDrugBrandNamesDetail from './pharmacy-drug-brand-names-detail';
import PharmacyDrugBrandNamesUpdate from './pharmacy-drug-brand-names-update';
import PharmacyDrugBrandNamesDeleteDialog from './pharmacy-drug-brand-names-delete-dialog';

const PharmacyDrugBrandNamesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyDrugBrandNames />} />
    <Route path="new" element={<PharmacyDrugBrandNamesUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyDrugBrandNamesDetail />} />
      <Route path="edit" element={<PharmacyDrugBrandNamesUpdate />} />
      <Route path="delete" element={<PharmacyDrugBrandNamesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyDrugBrandNamesRoutes;
